import { PaymentController } from "@icg360/payment-toolkit";
import { PaymentController as PaymentControllerV2 } from "@icg360/payment-toolkit-v2";

export const PAYMENT_READY = PaymentController.PAYMENT_READY;
export const PAYMENT_START = PaymentController.PAYMENT_START;
export const PAYMENT_CANCEL = PaymentController.PAYMENT_CANCEL;
export const PAYMENT_ERROR = PaymentController.PAYMENT_ERROR;
export const PAYMENT_COMPLETE = PaymentController.PAYMENT_COMPLETE;
export const SCHEDULED_PAYMENT_CREATED =
  PaymentControllerV2.SCHEDULED_PAYMENT_CREATED;
export const SCHEDULED_PAYMENT_CANCELED =
  PaymentControllerV2.SCHEDULED_PAYMENT_CANCELED;
